<template>
    <div class="phase_box">
        <div class="phase_tab_card">
            <div class="phase_tab_head">
                <div class="phase_tab_title">阶段统计</div>
                <div class="phase_tab_desc">按客户或厂家维度查看销售、购进、服务费和盈亏汇总</div>
            </div>
            <div class="tab_box">
                <div v-for="(item, index) in tabList" :key="index" @click="tabClick(index)"
                    :class="[tabIndex == index ? 'active' : '', 'tab_item']">{{ item }}</div>
            </div>
        </div>
        <customer-phase v-if="tabIndex == 0"></customer-phase>
        <mill-phase v-if="tabIndex == 1"></mill-phase>
    </div>
</template>
<script>
import CustomerPhase from './components/phaseComponents/CustomerPhase.vue';
import MillPhase from './components/phaseComponents/MillPhase.vue';
export default {
    name: 'phase',
    components:{
        CustomerPhase,
        MillPhase,
    },
    data() {
        return {
            tabIndex: 0,
            tabList: ['客户', '厂家'],
        }
    },
    methods: {
        // tab切换
        tabClick(index) {
            this.tabIndex = index;
        },
    },
}
</script>
<style scoped>
.phase_box {
    min-height: 100%;
    padding: 16px;
    box-sizing: border-box;
    background:
        radial-gradient(circle at 12% 8%, rgba(38, 137, 232, .14), transparent 28%),
        linear-gradient(180deg, #f6faff 0%, #eef5fb 100%);
}

.phase_tab_card {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    margin-bottom: 14px;
    padding: 16px 18px;
    border: 1px solid rgba(217, 231, 243, .96);
    border-radius: 16px;
    background: rgba(255, 255, 255, .96);
    box-shadow: 0 8px 24px rgba(31, 93, 154, .08);
    overflow: hidden;
}

.phase_tab_card::after {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 3px;
    content: '';
    background: linear-gradient(90deg, #2689e8, #69c0ff, rgba(105, 192, 255, 0));
}

.phase_tab_head {
    display: flex;
    align-items: flex-end;
    gap: 12px;
    min-width: 0;
}

.phase_tab_title {
    position: relative;
    padding-left: 12px;
    color: #183b5b;
    font-size: 18px;
    font-weight: 800;
    line-height: 1.2;
    white-space: nowrap;
}

.phase_tab_title::before {
    position: absolute;
    top: 2px;
    bottom: 2px;
    left: 0;
    width: 4px;
    border-radius: 4px;
    content: '';
    background: #2689e8;
}

.phase_tab_desc {
    color: #7b8fa6;
    font-size: 13px;
    line-height: 18px;
}

.tab_box {
    display: inline-flex;
    flex: 0 0 auto;
    gap: 6px;
    min-width: 184px;
    padding: 4px;
    border: 1px solid #d9e7f3;
    border-radius: 22px;
    background: #f3f8fd;
}

.tab_item {
    flex: 1;
    height: 34px;
    padding: 0 20px;
    border-radius: 17px;
    color: #51687f;
    font-size: 14px;
    font-weight: 700;
    line-height: 34px;
    text-align: center;
    cursor: pointer;
    transition: all .18s ease;
}

.tab_item:hover {
    color: #2689e8;
    background: rgba(38, 137, 232, .08);
}

.active {
    color: #fff;
    background: linear-gradient(135deg, #2689e8, #45a7ff);
    box-shadow: 0 6px 14px rgba(38, 137, 232, .22);
}

@media (max-width: 1180px) {
    .phase_tab_card,
    .phase_tab_head {
        align-items: flex-start;
        flex-direction: column;
    }

    .tab_box {
        width: 100%;
    }
}
</style>
